<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-cogs mr-5"></i>{{'amazon_config' | translate}} {{config.name}}</h3>
            <div class="box-tools pull-right">
              <button type="button" data-widget="collapse" class="btn btn-box-tool">
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12 col-md-6" v-if="company.erp_system === 'ipos'">
                <h5>{{'wws_config' | translate}}:</h5>
                <hr>
                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Status:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_active = 1"
                          :class="{'btn btn-success': true, 'active' : erp.is_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_active = 0"
                          :class="{'btn btn-danger': true, 'active': erp.is_active === 0}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>{{'deltaexport' | translate}}:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_delta_active = 1"
                          :class="{'btn btn-success': true, 'active': erp.is_delta_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_delta_active = 0"
                          :class="{'btn btn-danger': true, 'active': (erp.is_delta_active === 0 )}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label for="erpErpBaseUrl">{{'erp_base_url' | translate}}:</label>
                      <input
                        type="text"
                        v-validate="{regex: /^.{0,100}$/}"
                        v-model="erp.erp_base_url"
                        id="erpErpBaseUrl"
                        name="erpErpBaseUrl"
                        class="form-control"
                      >
                      <span v-show="errors.has('erpErpBaseUrl')" class="small text-danger">
                        {{ 'direct_listing_max_100' | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="erpErpUser">{{'wws_user' | translate}}:</label>
                      <input
                        type="text"
                        v-model="erp.erp_user"
                        v-validate="{regex: /^.{0,100}$/}"
                        name="erpErpUser"
                        id="erpErpUser"
                        class="form-control"
                      >
                      <span v-show="errors.has('erpErpUser')" class="small text-danger">
                        {{ 'direct_listing_max_100' | translate }}
                      </span>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="erpErpPassword">{{'wws_password' | translate}}:</label>
                      <input
                        type="text"
                        v-validate="{regex: /^.{0,100}$/}"
                        v-model="erp.erp_password"
                        id="erpErpPassword"
                        name="erpErpPassword"
                        class="form-control"
                      >
                      <span v-show="errors.has('erpErpPassword')" class="small text-danger">
                        {{'direct_listing_max_100' | translate}}
                      </span>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <small class="text-muted">{{'last_update' | translate}} {{erp.updated_at | dateFormat }} </small>
                    </div>
                    <div class="col-xs-12 col-md-6 text-right">
                      <button
                        type="button"
                        @click="updateErp"
                        :disabled="errors.has('erpErpBaseUrl') || errors.has('erpErpUser') || errors.has('erpErpPassword')"
                        class="btn btn-success"
                      >
                        {{'save' | translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-xs-12 col-md-6" v-if="company.erp_system === 'etos' || company.erp_system === 'etosApollon'">
                <h5>{{'wws_config' | translate}}:</h5>
                <hr>
                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Status:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_active = 1"
                          :class="{'btn btn-success': true, 'active' : erp.is_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_active = 0"
                          :class="{'btn btn-danger': true, 'active': erp.is_active === 0}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>{{'deltaexport' | translate}}:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_delta_active = 1"
                          :class="{'btn btn-success': true, 'active': erp.is_delta_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_delta_active = 0"
                          :class="{'btn btn-danger': true, 'active': (erp.is_delta_active === 0 )}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label for="etos_selling_store_id">{{'etos_sales_store' | translate }}:</label>
                      <input
                        type="text"
                        v-model="erp.etos_selling_store_id"
                        id="etos_selling_store_id"
                        v-validate="{regex: /^.{0,100}$/}"
                        name="etos_selling_store_id"
                        class="form-control"
                      >
                      <span v-show="errors.has('etos_selling_store_id')" class="small text-danger">
                        {{ 'direct_listing_max_100' | translate }}
                      </span>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <small class="text-muted">{{'last_update' | translate}} {{erp.updated_at | dateFormat }} </small>
                    </div>
                    <div class="col-xs-12 col-md-6 text-right">
                      <button
                        type="button"
                        @click="updateErp"
                        :disabled="errors.has('etos_selling_store_id')"
                        class="btn btn-success"
                      >
                        {{'save' | translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-xs-12 col-md-6" v-if="company.erp_system === 'bits'">
                <h5>{{'wws_config' | translate}}:</h5>
                <hr>
                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Status:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_active = 1"
                          :class="{'btn btn-success': true, 'active' : erp.is_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_active = 0"
                          :class="{'btn btn-danger': true, 'active': erp.is_active === 0}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>{{'deltaexport' | translate}}:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_delta_active = 1"
                          :class="{'btn btn-success': true, 'active': erp.is_delta_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_delta_active = 0"
                          :class="{'btn btn-danger': true, 'active': (erp.is_delta_active === 0 )}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <small class="text-muted">{{'last_update' | translate}} {{erp.updated_at | dateFormat }} </small>
                    </div>
                    <div class="col-xs-12 col-md-6 text-right">
                      <button type="button" @click="updateErp" class="btn btn-success">
                        {{'save' | translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-xs-12 col-md-6" v-if="company.erp_system === 'his'">
                <h5>{{'wws_config' | translate}}:</h5>
                <hr>
                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Status:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_active = 1"
                          :class="{'btn btn-success': true, 'active' : erp.is_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_active = 0"
                          :class="{'btn btn-danger': true, 'active': erp.is_active === 0}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>{{'deltaexport' | translate}}:</label><br>
                      <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                        <button
                          type="button"
                          @click="erp.is_delta_active = 1"
                          :class="{'btn btn-success': true, 'active': erp.is_delta_active === 1}"
                        >
                          <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                        </button>
                        <button
                          type="button"
                          @click="erp.is_delta_active = 0"
                          :class="{'btn btn-danger': true, 'active': (erp.is_delta_active === 0 )}"
                        >
                          <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="iShop">{{'his_i_shop' | translate}}:</label>
                      <input
                        type="text"
                        v-model="erp.his_ishop"
                        v-validate="{regex: /^.{0,100}$/}"
                        id="iShop"
                        name="iShop"
                        class="form-control"
                      >
                      <span v-show="errors.has('iShop')" class="small text-danger">
                        {{'direct_listing_max_100' | translate}}
                      </span>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="his_uvp_index">{{'uvp_index' | translate}}:</label>
                      <input
                        type="text"
                        v-model="erp.his_uvp_index"
                        v-validate="{regex: /^.{0,100}$/}"
                        id="his_uvp_index"
                        name="his_uvp_index"
                        class="form-control"
                      >
                      <span v-show="errors.has('his_uvp_index')" class="small text-danger">
                        {{'direct_listing_max_100' | translate}}
                      </span>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <small class="text-muted">{{'last_update' | translate}} {{erp.updated_at | dateFormat }} </small>
                    </div>
                    <div class="col-xs-12 col-md-6 text-right">
                      <button
                        type="button"
                        @click="updateErp"
                        :disabled="errors.has('iShop') || errors.has('his_payment_id') || errors.has('shipping_cost') || errors.has('his_uvp_index') || errors.has('prime_payment_id') || errors.has('prime_shipping_cost_id')"
                        class="btn btn-success"
                      >
                        {{'save' | translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div v-if="ftpFlag > 0">
                <div v-show="ftp.username != null" class="col-xs-12 col-md-6">
                  <h5>{{'ftp_config' | translate}}</h5>
                  <hr>
                  <form>
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label>{{'ftp_user_id' | translate}}:</label><br>
                        <input type="text" v-model="ftp.company_id" class="form-control"  disabled>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Status:</label><br>
                        <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                          <button
                            type="button"
                            @click="handleClickEvent(1)"
                            :class="{'btn btn-success': true, 'active': ftp.is_active === 1}"
                          >
                            <i class="fa fa-check mr-5"></i>{{'active' | translate}}
                          </button>
                          <button
                            type="button"
                            @click="handleClickEvent(0)"
                            :class="{'btn btn-danger': true, 'active': (ftp.is_active === 0 )}"
                          >
                            <i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                          </button>
                        </div>
                      </div>
                      <div class="form-group col-xs-12">
                        <label>{{'user' | translate}}:</label>
                        <input  type="text" v-model="ftp.username" class="form-control" disabled>
                      </div>
                      <div class="form-group col-xs-12">
                        <label>{{'password' | translate}}:</label>
                        <div class="row">
                          <div class="col-xs-12">
                            <input
                              v-validate="{ regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, required: true}"
                              type="password"
                              name="changePassword"
                              v-model="newFtpPassword"
                              :placeholder= "'new_password' | translate"
                              class="form-control"
                            >
                            <span v-show="errors.has('changePassword')" class="small text-danger">
                              {{ 'pwdErrorMsg' | translate }}
                            </span>
                          </div>
                        </div>
                        <hr>
                        <div class="row">
                          <div class="col-xs-12 col-md-6">
                            <small class="text-muted">{{'last_update' | translate}} {{ftp.updated_at | dateFormat}}</small>
                          </div>
                          <div class="col-xs-12 col-md-6 text-right">
                            <button
                              type="button"
                              :disabled="errors.has('changePassword') || newFtpPassword === ''"
                              @click="updateFtp()"
                              class="btn btn-info"
                            >
                              <i class="fa fa-save mr-5"></i>{{'change_password' | translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div v-show="ftp.username == null" class="col-xs-12 col-md-6">
                  <form>
                    <h5>{{'new_ftp_user' | translate}}:</h5>
                    <div class="row">
                      <div class="form-group col-xs-12">
                        <label>{{'user' | translate}}:</label>
                        <input  type="text" :placeholder=" 'generate_user' | translate " class="form-control" disabled>
                      </div>
                      <div class="form-group col-xs-12">
                        <label>{{'password' | translate}}:</label>
                        <input
                          v-validate="{ regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, required: true}"
                          data-vv-as="Password"
                          type="password"
                          v-model="ftp.password"
                          name="passwordFail"
                          class="form-control"
                        >
                        <span v-show="errors.has('passwordFail')" class="small text-danger">
                          {{ 'pwdErrorMsg' | translate }}
                        </span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="form-group col-xs-6">
                        <div class="radio">
                          <label class="mr-5">
                            <input type="radio" name="radio-a" @click="ftp.is_active = 1" value="true">
                            {{'activated' | translate}}
                          </label>
                          <label class="ml-5">
                            <input type="radio" name="radio-a" checked @click="ftp.is_active = 0" value="false">
                            {{'deactivated' | translate}}
                          </label>
                        </div>
                      </div>
                      <div class="col-xs-6 text-right">
                        <button
                          type="button"
                          @click="createFtp"
                          :disabled="ftp.password === '' || errors.has('passwordFail')"
                          class="btn btn-success"
                        >
                          {{'add_ftp_user' | translate}}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AmazonConfiguration.vue',
  data () {
    return {
      title: 'AmazonConfiguration',
      company:{},
      config: [],
      erp: {
        is_active: 0,
        is_delta_active: 0
      },
      ftp: {
        is_active: 0,
        password: ''
      },
      newFtpPassword: '',
      ftpFlag: 0
    }
  },
  methods: {
    getErp(){
      API.get(`/directsales/${this.$route.params.companyId}/erp`)
        .then(response => {
          this.erp = response.data
          this.ftpFlag = 1
        })},
    handleClickEvent(val){
      let data = {is_active: val}
      this.updateFtpStatus(data)
    },
    getFtp() {
      API.get(`/directsales/${this.$route.params.companyId}/ftp`)
        .then(response => {
          this.ftp = response.data
        })
    },
    updateErp () {
      API.put(`/directsales/${this.$route.params.companyId}/erp`, this.erp)
        .then(response => {
          let alert = {
            type: 'success',
            dismiss: 4,
            message: 'Successfully updated WWS Configuration'
          }
          this.$store.commit('pushAlert', alert)
          this.getErp()
        })
    },
    updateFtpStatus(data){
      API.put(`/directsales/${this.$route.params.companyId}/ftp`, data)
        .then(response => {
          this.getFtp()
        })
    },
    handleFtpIsActive(){
      if (ftp.is_active === null){
        ftp.is_active === 0}
    },
    createFtp(){
      API.put(`/directsales/${this.$route.params.companyId}/ftp`, this.ftp)
        .then(response => {
          let alert = {
            type: 'success',
            dismiss: 4,
            message: 'Successfully created FTP user'
          }
          this.$store.commit('pushAlert', alert)
          this.getFtp()
        })
    },
    updateFtp(){
      this.ftp.password = this.newFtpPassword
      API.put(`/directsales/${this.$route.params.companyId}/ftp`, this.ftp)
        .then(response => {
          let alert = {
            type: 'success',
            dismiss: 4,
            message: 'Successfully updated FTP Password'
          }
          this.newFtpPassword = ''
          this.$store.commit('pushAlert', alert)
        })
    },
    getErpSystemForCompany(){
     API.get(`/accounting/companies/${this.$route.params.companyId}`).then(response =>
     {
       this.company = response.data
     })
    }
  },
  mounted () {
    this.getErp()
    this.getFtp()
    this.getErpSystemForCompany()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/AmazonConfiguration.vue